@if (!loading) {
  <mat-form-field style="width: 100%" appearance="outline">
      <mat-label>{{placeholder}}</mat-label>
      <mat-select [disabled]="disabled || false" required
                  [formControl]="matSelectControl"
                  (valueChange)="handleValueChange($event);"
                  [errorStateMatcher]="matcher"
                  [placeholder]="placeholder || 'Sélectionner un élément'" #singleSelect>
          <mat-option>
              <ngx-mat-select-search [formControl]="matSelectSearchControl"
                                     [placeholderLabel]="label  || 'Saisissez les premières lettres de recherche'"
                                     [noEntriesFoundLabel]="noDatasLabel || 'Aucune donnée n\'a été trouvé'"
                                     [clearSearchInput]="clearSearchInput"
                                     [searching]="searching"></ngx-mat-select-search>
          </mat-option>
          @for (data of filteredDatas$ | ngrxPush; track data.key) {
            <mat-option [value]="data">
                {{getLibelle(data.value)}}
            </mat-option>
          }
      </mat-select>
  </mat-form-field>
}
@if (loading) {
  <div>{{labelLoader || 'Chargement en cours...'}}
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}
